"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slidewindowGroup = exports.slidewindow = void 0;
var seq = function (min, max) {
    var finalSeq = [];
    for (var i = min; i < max; i++)
        finalSeq.push(i);
    return finalSeq;
};
var seqMid = function (i, window) {
    if (window === 1)
        return [i];
    if (window % 2 === 0)
        return [];
    var half = (window - 1) / 2;
    var finalSeq = [];
    for (var j = i - half; j < i + half + 1; j++)
        finalSeq.push(j);
    return finalSeq;
};
var slidewindow = function (i, count, window) {
    if (window === 1)
        return [i];
    if (window > count)
        return seq(0, count);
    var startingSeq = seq(0, window);
    var endingSeq = seq(count - window, count);
    var startingSeqMidIndex = Math.ceil(window / 2) - 1;
    if (i <= startingSeq[startingSeqMidIndex])
        return startingSeq;
    var endingSeqMidIndex = Math.ceil(window / 2) - 1;
    if (i >= endingSeq[endingSeqMidIndex])
        return endingSeq;
    return seqMid(i, window);
};
exports.slidewindow = slidewindow;
var arrayEquals = function (arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2))
        return false;
    if (arr1.length !== arr2.length)
        return false;
    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i])
            return false;
    }
    return true;
};
var lastElement = function (array1) {
    if (!Array.isArray(array1))
        return null;
    if (!array1)
        return null;
    if (!array1.length)
        return null;
    return array1[array1.length - 1];
};
var removeDuplicate = function (array1) {
    var newArray1 = [];
    for (var i = 0; i < array1.length; i++) {
        var lastArray = lastElement(newArray1);
        var currentArray = array1[i];
        if (lastArray === null || !arrayEquals(lastArray, currentArray))
            newArray1.push(currentArray);
    }
    return newArray1;
};
var slidewindowGroup = function (count, window) {
    var group = [];
    for (var i = 0; i < count; i++) {
        group.push(slidewindow(i, count, window));
    }
    return removeDuplicate(group);
};
exports.slidewindowGroup = slidewindowGroup;
